import React from 'react';
import { Divider } from '@fiverr-private/layout_components';
import { SellerPageFederatedSeller, useSellerData } from '@fiverr-private/seller_pages_toolbox';
import { useSellerReviews } from '../../hooks/useSellerReviews';
import { SellerReviews } from '../SellerReviews';
import { StickyHeader } from '../StickyHeader';
import { createTabId } from '../StickyHeader/tab-names';
import { wrClass } from './RolePageReviews.ve.css';

interface RolePageReviewsProps {
    sellerRoleId?: string;
    areReviewsLoading: boolean;
    withBottomDivider?: boolean;
}

export const RolePageReviews: React.FC<RolePageReviewsProps> = ({
    withBottomDivider = false,
    areReviewsLoading,
    sellerRoleId,
}) => {
    const { approvedGigsCount } = useSellerData(selectSellerSlice);
    const reviews = useSellerReviews();
    if (!reviews) {
        return null;
    }
    const showBuyingReviews = reviews?.buying_reviews?.reviews?.length > 0 && approvedGigsCount > 0;

    const showSellingReviews = reviews?.selling_reviews?.reviews?.length > 0 && !approvedGigsCount;
    const shouldRenderReviews = Boolean(showBuyingReviews || showSellingReviews);

    if (!shouldRenderReviews || areReviewsLoading) {
        return null;
    }

    return (
        <>
            <Divider />
            <div
                id={createTabId({
                    tabId: StickyHeader.TabName.Reviews,
                    roleId: sellerRoleId,
                })}
                className={wrClass}
            >
                <SellerReviews isReviewItemFullWidth />
            </div>
            {withBottomDivider && <Divider />}
        </>
    );
};

function selectSellerSlice(seller: SellerPageFederatedSeller) {
    return {
        approvedGigsCount: seller.approvedGigsCount,
    };
}
